// Initialize masonry
var windowOnloadCopy = window.onload;
window.onload = function () {
  if (windowOnloadCopy) {
    windowOnloadCopy();
  }
  let element_needs_masonry = document.querySelector('.masonry');
  if (element_needs_masonry) {
    let masonry = new window.masonry(element_needs_masonry, {
      itemSelector: '.masonry__brick',
      percentPosition: true,
      resize: true,
      horizontalOrder: true
    });
    masonry.on('');
  }


  //For new works
  let newWorksMasonryGrid = document.querySelector('.masonry-grid');
  if (newWorksMasonryGrid) {
    var win = $(window);
    var doc = $(document);
    var loading = false;
    var allLoaded = false;
    var plusOffset = 500;
    var footerHeight = $('.s-footer').height() + $('.s-social').height();


    win.scroll(function() {
      var heightOffeset = win.scrollTop() + win.height() + footerHeight + plusOffset;

      if (heightOffeset > doc.height()) {
        if (loading || allLoaded) return;

        loading = true;
        ajaxRequest();
        $('.new-works-loader').css('display', 'block');
      }
    });

    let msnry = new window.masonry(newWorksMasonryGrid, {
      itemSelector: '.masonry__brick',
      percentPosition: true,
      resize: false,
      horizontalOrder: true
    });

    var limit = 15,
      offset = 15;

    function ajaxRequest() {
      $.ajax({
        url: '/api/new-works',
        type: 'GET',
        data: {
          limit: limit,
          offset: offset,
        },
        dataType: 'json',
        success: function (newWorks) {
          displayNewWorks(newWorks);

          offset += limit;

          if (newWorks.length < limit) {
            allLoaded = true;
          }

          $('.new-works-loader').css('display', 'none');
          setTimeout(function() {
            loading = false;
          }, 1000);
        },
      });
    }

    setInterval(function () {
      msnry.layout();
    }, 1500);

    function displayNewWorks(newWorks) {
      newWorks.forEach(function (newWorkItem) {
        var newWork = newWorkItem.workable;

        var illustrator = newWork.illustrator;
        var user = illustrator.user;

        var template = $('.new-work-item').first().clone();
        template.removeClass('new-work-item');

        if (newWorkItem.isSet) {
          template.find('.set-icon').css('display', 'block');
        }

        template.find('.img-link').attr('href', newWorkItem.entityUrl);
        template.find('.author-link').attr('href', newWorkItem.entityUrl);
        template.find('.author-link').text(illustrator.first_name + ' ' + illustrator.last_name);
        template.find('.img-link img').attr('src', newWork.imagePath).attr('title', newWork.title);
        template.find('.author-logo-link').attr('href', '/' + user.name + '/portfolio');
        template.find('.author-logo-link img').attr('src', illustrator.avatarPicture);

        template.css('display', 'block');

        $('.masonry-grid').append(template);
        msnry.appended(template);
        msnry.layout();
      });
    }
  }
};